// extracted by mini-css-extract-plugin
export default {"root":"ValidationAlert_root__j0o2X"};